import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from '../../../../../environments/environment';
import { FormServices } from 'src/app/services/form-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { FileService } from 'src/app/services/file.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-show-product',
  templateUrl: './show-product.component.html',
  styleUrls: ['./show-product.component.scss'],
})
export class ShowProductComponent implements OnInit, OnDestroy {
  @ViewChild('badge', { static: true }) badge;
  @Input() edit: any;
  public fieldForms = undefined;
  public domainId = environment.domainId;
  public imagesUploaded: any[] = [];
  public urlImg: string = environment.uriProduct;
  public selectedRoute = 'data';
  public options = [];
  public inventory = [];
  public description = undefined;
  public isUploading = false;
  public savedForm = undefined;
  public productId: number = undefined;
  public buttons = [
    {
      name: 'Datos esenciales',
      value: 'data',
    },
    {
      name: 'Descripción',
      value: 'description',
    },
    {
      name: 'Opciones',
      value: 'options',
    },
    {
      name: 'Más información',
      value: 'info',
    },
    {
      name: 'Inventario',
      value: 'inventory',
    },
  ];
  public dataProduct: FormData = new FormData();
  public sended = true;
  public haveErrors: any[] = [];
  public id = undefined;
  public existDistributor = false;
  public longDescription = undefined;
  private _sign: Subscription;
  private _idSuscription: Subscription = new Subscription();

  constructor(
    public formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService,
    public paramSv: ParamServicesService,
    private route: ActivatedRoute,
    private translateSv: TranslateService,
    private loginSv: LoginService
  ) {}

  ngOnInit() {
    this._idSuscription = this.route.queryParams.subscribe((params) => {
      this.clear();
      this.id = params.product;
    });
    if (this.paramSv.existDistributorSignUp) {
      this.existDistributor = this.paramSv.existDistributorSignUp;
      this.buttons.push({
        name: 'Productos al Mayor',
        value: 'wholesale',
      });
    }
    // this.existDistributor = this.paramSv.existDistributorSignUp;
    this._sign = this.paramSv.existDistributorSignUpObs.subscribe(
      (item: boolean) => {
        if (item) {
          this.existDistributor = item;
          this.buttons.push({
            name: 'Productos al Mayor',
            value: 'wholesale',
          });
        }
        this._sign.unsubscribe();
      }
    );
  }

  clear() {
    this.formSv.clearFormSrc.next();
    this.productId = undefined;
  }

  hiddeSegment(ev) {
    const index = this.buttons.findIndex((x) => x.value === ev);
    if (index != -1) {
      this.buttons.splice(index, 1);
    }
    if (this.buttons.length === 1) {
      this.selectedRoute = this.buttons[0].value;
    }
  }

  ngOnDestroy(): void {
    this._sign.unsubscribe();
    this._idSuscription.unsubscribe();
  }

  setImage(file) {
    this.imagesUploaded = file;
  }

  getData() {
    this.formSv.getDataSrc.next();
    this.uploadProduct();
  }

  async uploadProduct() {
    try {
      const haveError = this.haveErrors.find((item) => item.value === false);
      if (haveError?.value === false) {
        this.haveErrors = [];
        this.options = [];
        this.inventory = [];
        const translate = this.translateSv.instant(
          'VERIFICA_QUE_ESTEN_LLENOS_LOS_CAMPOS_DE_CADA_SECCION'
        );
        await this.uiSv.showToast(translate);
        return;
      }
      if (!this.productId) {
        this.options.map((item) => {
          delete item.id;
        });
        this.inventory.map((item) => {
          delete item.id;
        });
      }

      const promo = this.dataProduct.get('promotionalPrice');
      const normalPrice = this.dataProduct.get('price');
      const promoDist = this.dataProduct.get('promotionalPriceWSale');
      const normalPriceDist = this.dataProduct.get('priceWSale');
      if (promo && normalPrice && Number(promo) >= Number(normalPrice)) {
        return await this.uiSv.showToast(
          'El precio promocional debe ser menor al precio normal.'
        );
      }

      if (
        promoDist &&
        normalPriceDist &&
        Number(promoDist) >= Number(normalPriceDist)
      ) {
        return await this.uiSv.showToast(
          'El precio promocional mayorista debe ser menor al precio normal mayorista.'
        );
      }

      await this.uiSv.showLoading();
      if (this.loginSv.user.rolId === 4) {
        for (const key in this.savedForm) {
          this.dataProduct.set(key, this.savedForm[key]);
        }
      }
      this.dataProduct.set('options', JSON.stringify(this.options));
      this.dataProduct.set('inventory', JSON.stringify(this.inventory));
      this.productId && this.dataProduct.set('id', String(this.productId));
      this.dataProduct.set('longDescription', this.longDescription);
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(
        this.dataProduct,
        'product',
        this.productId ? 'update' : 'store'
      );
      this.isUploading = false;
      const translate = this.translateSv.instant(
        'PRODUCTO_GUARDADO_EXITOSAMENTE'
      );
      await this.uiSv.showToast(translate);
      if (res.status) {
        this.productId = undefined;
        this.savedForm = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
        this.options = [];
        this.inventory = [];
        this.haveErrors = [];
        this.dataProduct = new FormData();
        this.buttons = this.buttons.filter(
          (item) => item.value !== 'groupOptions'
        );
      }
      this.sended = false;
      setTimeout(async () => {
        this.sended = true;
        await this.uiSv.loading.dismiss();
      }, 500);
      this.formSv.clearFormSrc.next('setUndefined');
    } catch (err) {
      await this.uiSv.loading.dismiss();
      this.isUploading = false;
      this.options = [];
      this.inventory = [];
      if (err?.error?.error?.messages?.errors[0]) {
        const errRule = err?.error?.error?.messages.errors[0];
        const trMsg = this.translateSv.instant('EL_CAMPO_NOMBRE_DEBE_TENER');
        const trMinOrMax =
          errRule.rule === 'minLength'
            ? this.translateSv.instant('MINIMO')
            : this.translateSv.instant('MAXIMO');
        const trCr = this.translateSv.instant('CARACTERES');
        const msg = `${trMsg} ${trMinOrMax}: ${
          errRule.args.minLength || errRule.args.maxLength
        } ${trCr}`;
        await this.uiSv.presentAlert(msg, false);
      } else if (
        err?.error?.error ===
        'ValidationException: E_VALIDATION_FAILURE: Validation Exception'
      ) {
        const tr = this.translateSv.instant(
          'VERIFICA_QUE_TODOS_LOS_CAMPOS_ESTEN_LLENOS'
        );
        await this.uiSv.presentAlert(tr);
      }
    }
  }

  saveDataProduct(ev?: any, isDescription?) {
    try {
      if (ev?.value === false && isDescription) {
        this.longDescription = null;
        return false;
      }
      ev.forEach((item, key) => {
        if (key === 'longDescription' && isDescription) {
          this.longDescription = item;
        } else {
          this.dataProduct.set(key, item);
        }
      });
    } catch (err) {
      console.error(err);
      this.haveErrors.push(ev);
    }
  }

  async saveOptions(ev: FormData, type) {
    if (type === 1) {
      this.options.push(ev);
    } else {
      this.inventory.push(ev);
    }
  }

  async getProduct({ product, action, changeAction }) {
    try {
      const { id, savedForm } = await this.fileSv.getProduct(
        { product: Object.assign({}, product), action, changeAction },
        this.productId,
        'product',
        'Producto',
        this.savedForm
      );

      this.productId = id;
      this.savedForm = undefined;

      if (action !== 'delete') {
        savedForm && savedForm.existence === null
          ? (savedForm.existenceNull = false)
          : (savedForm.existenceNull = true);
        setTimeout(() => {
          if (savedForm.video === 'null') {
            savedForm.video = null;
          }
          if (product.coverImages)
            savedForm.cover = [{ file: product.coverImages }];
          savedForm.inventory.forEach((x) => {
            x.existence = x.existence === null || x.existence ? true : 0;
            if (
              this.loginSv.user.rolId === 4 &&
              x.branchContactId !== this.loginSv.user.branchContactId
            ) {
              x.noVisible = true;
            }
          });
          this.savedForm = savedForm;
          if (this.savedForm.grupoOptions.length) {
            if (!this.buttons.find((item) => item.value === 'groupOptions')) {
              this.buttons.push({
                name: 'Grupos de opciones',
                value: 'groupOptions',
              });
            }
          } else {
            this.buttons = this.buttons.filter(
              (item) => item.value !== 'groupOptions'
            );
          }
        }, 1);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
